import React, { useState } from 'react'
import { ViewStyle, TextStyle, View } from 'react-native'
import { TextField } from '@trivie/ui-web/components/text-field'

import { useStores } from '@trivie/core'
import { color, Header, iconArrowBack, Text, Button } from '@trivie/ui-mobile'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'

export const ReportProblemScreen = () => {
  const { userStore } = useStores()
  const { reportProblem } = userStore
  const history = useHistory()
  const { t } = useTranslation()
  const subHeader = t('Settings.HowCanWeImprove')
  const formPlaceholder = t('Settings.reportProblemPlaceholder')

  const goBack = () => {
    history.goBack()
  }

  const submitAnotherReport = () => {
    setIsConfirmed(false)
    setMessage('')
  }

  const { control } = useForm()

  const [message, setMessage] = useState<string>('')

  const [isConfirmed, setIsConfirmed] = useState(false)
  const [responseString, setResponseString] = useState<string | undefined>(undefined)

  const sendReport = () => {
    setIsConfirmed(true)
    reportProblem(message, 'New Support Message').then(() => {
      if (userStore.status === 'done') {
        setIsConfirmed(true)
      } else {
        setResponseString('Unfortunately your feedback could not be submitted at this time.')
        setIsConfirmed(true)
      }
    })
  }

  return (
    <View testID="SettingsScreen" style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={goBack}
          center
          titleStyle={HEADER}
          headerTx="Settings.ReportProblem"
        />

        <View style={{ position: 'relative' }}>
          <Controller
            defaultValue=""
            name="Testing"
            required
            control={control}
            render={() => (
              <View>
                <label style={LABEL_STYLE} htmlFor="txtReportField">
                  {subHeader}
                </label>

                <TextField
                  id="txtReportField"
                  // @ts-ignore
                  dataSet={{ qat: `text_report_input` }}
                  multiline
                  rows={15}
                  placeholder={formPlaceholder}
                  variant="outlined"
                  onChange={(e) => setMessage(e.target.value)}
                  value={message}
                  style={TEXTAREA_STYLE}
                />
                <div style={{ width: '35%', margin: '0 auto' }}>
                  <Button
                    // @ts-ignore
                    dataSet={{ qat: `send_report_btn` }}
                    accessibilityRole="button"
                    accessibilityLabel="Send report"
                    onPress={sendReport}
                    disabled={!message}
                    style={{
                      backgroundColor: !message ? color.lightGrey : color.palette.blue,
                      height: 52,
                      marginTop: 10,
                      paddingTop: 15,
                      paddingBottom: 15,
                      borderRadius: 16,
                    }}
                  >
                    <Text
                      variant="body1Emphasized"
                      tx="Common.send"
                      style={{
                        fontSize: 17,
                        lineHeight: 22,
                        fontWeight: '600',
                        color: color.white,
                      }}
                    />
                  </Button>
                </div>

                {isConfirmed ? (
                  <div
                    style={{
                      position: 'absolute',
                      left: '0%',
                      right: '0%',
                      top: '2%',
                      bottom: '0%',
                      backgroundColor: 'white',
                      zIndex: 1000,
                      textAlign: 'center',
                    }}
                  >
                    <div
                      style={{
                        margin: '0 auto',
                        paddingTop: 100,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <h3>Thanks!</h3>
                      <p style={{ marginTop: 1 }}>
                        {!responseString
                          ? 'Your feedback helps make Trivie better. We’ll contact you if we need more details.'
                          : responseString}
                      </p>
                      <div style={{ width: '35%', margin: '0 auto' }}>
                        <Button
                          // @ts-ignore
                          dataSet={{ qat: `send_another_report_btn` }}
                          accessibilityRole="button"
                          accessibilityLabel="Send another report"
                          onPress={submitAnotherReport}
                          style={{
                            backgroundColor: color.lightGrey,
                            height: 52,
                            paddingRight: 15,
                            paddingLeft: 15,
                            borderRadius: 16,
                            marginRight: 20,
                            marginLeft: 20,
                            marginTop: 20,
                            // zIndex: !message ? -1 : -1,
                          }}
                        >
                          <Text
                            variant="body1Emphasized"
                            tx="Common.ok"
                            style={{
                              fontSize: 17,
                              lineHeight: 22,
                              fontWeight: '600',
                              color: color.black,
                            }}
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </View>
            )}
          />
        </View>
      </div>
    </View>
  )
}

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const LABEL_STYLE: React.CSSProperties = {
  fontSize: '1.17em',
  marginLeft: '18.6%',
  margin: 'auto',
  paddingBottom: '1%',
  fontWeight: 'bold',
  marginTop: 32,
  marginBottom: 32,
}
const TEXTAREA_STYLE: React.CSSProperties = {
  width: '100%',
  margin: '0 auto',
  borderWidth: 1,
  marginBottom: 40,
  borderRadius: 6,
}

const HEADER: TextStyle = { fontSize: 24, color: color.black, fontWeight: '700' }
